export const beforeItems = [
  "You spend valuable time searching for visual communication materials.",
  "You struggle to organize observations into practical planning priorities.",
  "You have multiple worksheets, activities, and resources scattered across different folders.",
  "You want to support communication beyond structured therapy sessions but need more practical examples.",
  "You find it challenging to coordinate communication supports with families, teachers, and caregivers.",
  "You frequently recreate visual schedules, communication boards, and planning templates.",
];

export const afterItems = [
  "Organize communication observations using structured worksheets.",
  "Access visual communication planning examples in one place.",
  "Follow a practical framework for identifying communication opportunities.",
  "Prepare adaptable communication supports for everyday activities.",
  "Coordinate planning discussions with families and educators.",
  "Document observations, adjustments, and follow-up priorities more consistently.",
];

export const challenges = [
  {
    icon: "puzzle",
    title: "You know communication support matters, but planning can feel overwhelming.",
    body: [
      "Every child has unique strengths, preferences, access needs, and ways of communicating.",
      "You want a clearer way to organize those considerations without relying on a one-size-fits-all approach.",
    ],
  },
  {
    icon: "speech",
    title: "You want more practical communication activities.",
    body: [
      "You understand communication concepts, but you need usable examples, planning worksheets, and visual resources that connect with everyday interactions.",
    ],
  },
  {
    icon: "clipboard",
    title: "Your observations and documentation are scattered.",
    body: [
      "You record important information about communication attempts, participation, and environmental barriers.",
      "But keeping everything organized can become difficult.",
    ],
  },
  {
    icon: "image",
    title: "You spend too much time preparing visual supports.",
    body: [
      "Visual schedules, communication boards, choice boards, and activity resources can require considerable preparation.",
      "You want adaptable starting points rather than rebuilding everything.",
    ],
  },
  {
    icon: "school",
    title: "You want communication support to extend beyond therapy.",
    body: [
      "Communication opportunities happen during meals, classroom activities, play, transitions, and family routines.",
      "You need resources that help organize support across those environments.",
    ],
  },
  {
    icon: "handshake",
    title: "You want better collaboration with families and educators.",
    body: [
      "Communication support works best when the people involved understand the child’s communication system and have opportunities to participate.",
      "You want practical materials to facilitate those conversations.",
    ],
  },
] as const;

export const tools = [
  {
    icon: "puzzle",
    title: "Communication Profile Organizer",
    body: "A structured worksheet for documenting communication strengths, preferences, access needs, and participation opportunities.",
  },
  {
    icon: "speech",
    title: "Functional Communication Observation Checklist",
    body: "A practical recording tool for organizing observations across activities and environments.",
  },
  {
    icon: "image",
    title: "Visual Communication Planning Templates",
    body: "Editable planning layouts for organizing communication boards, visual schedules, and activity supports.",
  },
  {
    icon: "school",
    title: "Everyday Communication Opportunity Planner",
    body: "A worksheet for identifying meaningful communication opportunities during daily routines.",
  },
  {
    icon: "handshake",
    title: "Communication Partner Collaboration Guide",
    body: "A structured resource for organizing discussions with families, educators, and other support professionals.",
  },
] as const;

export const heroIncludes = [
  { icon: "book", label: "6 Comprehensive Digital Volumes" },
  { icon: "gift", label: "5 Exclusive Practical Bonuses" },
  { icon: "puzzle", label: "Visual Communication Planning Templates" },
  { icon: "clipboard", label: "Functional Communication Observation Checklists" },
  { icon: "speech", label: "AAC & Communication Support Frameworks" },
  { icon: "school", label: "Home, Classroom & Therapy Resources" },
  { icon: "handshake", label: "Family and Communication Partner Collaboration Tools" },
] as const;

export const finalIncludes = [
  { icon: "book", label: "6 Practical Digital Volumes" },
  { icon: "gift", label: "5 Exclusive Specialized Bonuses" },
  { icon: "puzzle", label: "Visual Communication Planning Templates" },
  { icon: "speech", label: "AAC Support Organization Frameworks" },
  { icon: "clipboard", label: "Functional Observation Worksheets" },
  { icon: "school", label: "Everyday Communication Planning Resources" },
  { icon: "handshake", label: "Family & Educator Collaboration Tools" },
] as const;
